<template>
  <p :class="$style.container">{{formattedDuration}}</p>
</template>

<script>
  import moment from 'moment'
  import formatDuration from '@/lib/format-duration'
  import { createNamespacedHelpers } from 'vuex'

  const { mapState, mapGetters } = createNamespacedHelpers('conference')

  export default {
    data () {
      return {
        duration: 0
      }
    },
    computed: {
      ...mapState([
        'activity'
      ]),
      ...mapGetters([
        'callStatus'
      ]),
      formattedDuration () {
        return formatDuration(this.duration)
      }
    },
    watch: {
      callStatus: {
        handler (value) {
          if (value === 'in-progress') {
            this.startTimer()
          } else {
            this.stopTimer()
          }
        },
        immediate: true
      }
    },
    methods: {
      startTimer () {
        const start = moment.utc(this.activity.actualStartTime)

        this.$_timer = window.setInterval(() => {
          this.duration = moment.utc().diff(start)
        }, 1000)
      },
      stopTimer () {
        window.clearInterval(this.$_timer)
      }
    }
  }
</script>

<style module lang="less" src="./call-duration.less"></style>



// WEBPACK FOOTER //
// call-duration.vue?184fd055